import BaseServiceHttp from '../baseService'
class Exemplares extends BaseServiceHttp {
  constructor(id) {
    const resource = 'exemplares'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Exemplares(id)
